"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.typo = void 0;
const utils_1 = require("../utils");
const FONT = '"Open Sans", sans-serif';
const LIGHTER = '200';
const NORMAL = '400';
const SEMI_BOLD = '600';
const BOLD = '700';
exports.typo = {
    typoFontFamily: (0, utils_1.designToken)(FONT),
    typoBaseFont: (0, utils_1.designToken)(`${NORMAL} 13px/16px ${FONT}`),
    typoFontWeightLighter: (0, utils_1.designToken)(LIGHTER),
    typoFontWeightNormal: (0, utils_1.designToken)(NORMAL),
    typoFontWeightSemiBold: (0, utils_1.designToken)(SEMI_BOLD),
    typoFontWeightBold: (0, utils_1.designToken)(BOLD),
    typoFontSizeS: (0, utils_1.designToken)('12px'),
    typoFontSizeM: (0, utils_1.designToken)('13px'),
    typoFontSizeL: (0, utils_1.designToken)('15px'),
    typoFontSizeXL: (0, utils_1.designToken)('21px'),
    typoFontXL: (0, utils_1.designToken)(`${NORMAL} 21px/26px ${FONT}`),
    typoFontL: (0, utils_1.designToken)(`${NORMAL} 15px/18px ${FONT}`),
    typoFontLBold: (0, utils_1.designToken)(`${BOLD} 15px/18px ${FONT}`),
    typoFontMain: (0, utils_1.designToken)(`${NORMAL} 13px/16px ${FONT}`),
    typoFontMainSemiBold: (0, utils_1.designToken)(`${SEMI_BOLD} 13px/16px ${FONT}`),
    typoFontMainBold: (0, utils_1.designToken)(`${BOLD} 13px/16px ${FONT}`),
    typoFontSecondary: (0, utils_1.designToken)(`${NORMAL} 12px/14px ${FONT}`),
    typoFontSecondarySemiBold: (0, utils_1.designToken)(`${SEMI_BOLD} 13px/16px ${FONT}`),
    typoFontSecondaryBold: (0, utils_1.designToken)(`${BOLD} 12px/14px ${FONT}`),
    typoFontList: (0, utils_1.designToken)(`${NORMAL} 13px/24px ${FONT}`),
    typoFontBulletedList: (0, utils_1.designToken)(`${NORMAL} 13px/20px ${FONT}`),
    typoFontNumberList: (0, utils_1.designToken)(`${NORMAL} 13px/20px ${FONT}`)
};
//# sourceMappingURL=typo.js.map